import { Breadcrumb } from '@components/breadcrumb';
import { IconEmail } from '@components/icons/email';
import { IconTextBookmark } from '@components/icons/text-bookmark';
import { PageContainers } from '@components/page-containers';
import { SettingsCard } from '@components/settings-card';

import { useCompanyInfo } from 'api/companies/hooks';
import { Header } from 'components/headers';
import { Loading } from 'components/Loading';
import { PageContent } from 'components/Page';
import { SettingsSection } from 'components/settings-section';
import { useModal } from 'features/modals';
import { useStore } from 'models/Provider';

import { CompanyInfo } from './company-info';
import { DeadlineSettings } from './deadline-settings';
import { GoogleAnalyticsTrackingCode } from './google-analytics-tracking-code';

export const CompanySettings = () => {
  const { t } = useStore();
  const { showModal } = useModal();
  const companyQuery = useCompanyInfo();
  const company = companyQuery.data;

  return !company ? (
    <Loading />
  ) : (
    <>
      <Header
        breadcrumbs={<Breadcrumb items={[{ label: t('company.settings.company.header') }]} />}
      />
      <PageContent>
        <PageContainers.MiddleColumnPage>
          <SettingsSection title={t('company.settings.root.details')} hasSeparator isBordered>
            <CompanyInfo companyName={company.companyName} url={company.url} />
          </SettingsSection>
          <SettingsSection
            title={t('company.settings.root.messagessendername.title')}
            hasSeparator
            description={t('company.settings.root.messagessendername.description')}
          >
            <SettingsCard
              title={t('company.settings.root.messagessendername.title')}
              description={
                company.senderName ?? t('company.settings.root.messagessendername.placeholder')
              }
              icon={<IconEmail />}
              onEdit={() =>
                showModal('EDIT_MESSAGES_SENDER_NAME', {
                  currentSenderName: company.senderName,
                })
              }
            />
          </SettingsSection>
          <SettingsSection
            title={t('company.settings.root.ga.title')}
            hasSeparator
            description={t('company.settings.root.ga.description')}
          >
            <GoogleAnalyticsTrackingCode currentGaTracker={company.gaTracker} />
          </SettingsSection>
          <SettingsSection
            title={t('company.settings.root.privacy.title')}
            hasSeparator
            description={t('company.settings.root.privacy.description')}
          >
            <SettingsCard
              title={t('company.settings.root.privacy.title')}
              description={
                company.privacyPolicyUrl ?? t('company.settings.root.privacy.placeholder')
              }
              icon={<IconTextBookmark />}
              onEdit={() =>
                showModal('EDIT_PRIVACY_POLICY_URL', {
                  currentPrivacyPolicyUrl: company.privacyPolicyUrl,
                })
              }
            />
          </SettingsSection>
          <SettingsSection
            title={t('company.settings.root.deadline.title')}
            description={t('company.settings.root.deadline.description')}
          >
            <DeadlineSettings isDeadlineRequired={company.isDeadlineRequired} />
          </SettingsSection>
        </PageContainers.MiddleColumnPage>
      </PageContent>
    </>
  );
};
